// Libraries
import classNames from "classnames";
import { useObserver } from "mobx-react-lite";
import React, { ReactElement } from "react";

// Core
import { isEmptyOrWhitespace } from "../../../../Core/Utils/Utils";

// Custom
import { BQSRowStyle } from "./../BQSPrimitivesStyle";

interface IProps {
    className?: string;
}

export const BQSRow: React.FC<IProps> = (props: any) => {
    // #region Code Behind

    const rowClasses = BQSRowStyle();

    const getClassName = (): string => {
        return classNames({
            BQSRow: true,
            [`${props.className}`]: !isEmptyOrWhitespace(props.className),
            [`${rowClasses.root}`]: true,
        });
    };

    const renderChildrenWithProps = (): JSX.Element => {
        const childrenWithProps = React.Children.map(props.children, (child) => {
            return React.cloneElement(child as React.ReactElement<any>, {});
        });

        return <React.Fragment>{childrenWithProps}</React.Fragment>;
    };

    // #region Code Behind

    // #region Render Result
    return useObserver(() => <div className={getClassName()}>{renderChildrenWithProps()}</div>);

    // #endregion Render Result
};
